import TemplateApi from "../api/TemplateApi";
import {closeDrawer} from "./drawerActions";
import {initGetTemplateList} from "./templateListActions";
import * as TEMPLATE from "../constants/templateConstants";
import * as types from "../constants/actionConstants";
import {notificationOpen} from "./notificationActions";
import {runTrackedTemplateSave} from "./templateSaveActions";
import {
    captureEditorOrigin,
    questionEditorAnswerTargetMatches,
    runIfEditorOwnerActive
} from "../utilities/editorInstanceOwnership";


export function getActionTemplate(templateKey, id) {
    let thunk = (dispatch)=>{
        if (id){
            TemplateApi.getActionById(id).then((actionTemplate) =>{
                dispatch({type: types.ACTION_TEMPLATE_GET_SUCCESS , actionTemplate});
            });
        }
        else {
            TemplateApi.getCurrentAction(templateKey).then((actionTemplate) =>{
                dispatch({type: types.ACTION_TEMPLATE_GET_SUCCESS , actionTemplate});
            });
        }
    };

    thunk.meta = {
        debounce: {
            time: 2000,
            key: id || templateKey,
            leading: true,
            trailing: false
        }
    };

    return thunk;
}


export function createActionTemplate(actionTemplateObject, parentOrigin = null) {
    const origin = captureEditorOrigin(parentOrigin);
    return (dispatch, getState)=>{
        if (origin && !questionEditorAnswerTargetMatches(origin, getState(), actionTemplateObject.answerIndex)) {
            const error = new Error("Select an active answer before creating an action.");
            dispatch(notificationOpen(error.message));
            return runTrackedTemplateSave(dispatch, () => Promise.reject(error));
        }
        return runTrackedTemplateSave(dispatch, () =>
            TemplateApi.createActionTemplate(actionTemplateObject)
            .then((actionTemplate) =>{
                dispatch({type: types.ACTION_TEMPLATE_CREATE_SUCCESS, actionTemplate, origin});

                if (actionTemplateObject.answerIndex || actionTemplateObject.answerIndex === 0) {
                    dispatch({
                        type: types.QUESTION_EDITOR_ADD_ACTION,
                        actionTemplate,
                        answerIndex: actionTemplateObject.answerIndex,
                        depth: origin?.depth ?? 0,
                        origin
                    });
                }
                return actionTemplate;
            })
        );
    };
}


export function saveActionTemplateAndCloseDrawer(actionTemplateObject, filter, versionsFilter, templateMode, requestOwner = null) {
    const owner = captureEditorOrigin(requestOwner);
    return (dispatch, getState)=>{
        return runTrackedTemplateSave(dispatch, () =>
            TemplateApi.saveActionTemplate(actionTemplateObject)
            .then((actionTemplate) =>{
                dispatch({type: types.ACTION_TEMPLATE_UPDATE_SUCCESS , actionTemplate});
                runIfEditorOwnerActive(getState, owner, () => dispatch(closeDrawer()));

                // Best to load question list page in all cases
                dispatch(initGetTemplateList(filter, TEMPLATE.TYPE.ACTION, TEMPLATE.MODE.CURRENT));
                if (templateMode === TEMPLATE.MODE.VERSIONS) {
                    let tempVersionsFilter = {...versionsFilter};
                    tempVersionsFilter.templateName = actionTemplateObject.name;
                    tempVersionsFilter.templateKey = actionTemplateObject.templateKey;
                    dispatch(initGetTemplateList(tempVersionsFilter, TEMPLATE.TYPE.ACTION, TEMPLATE.MODE.VERSIONS));
                }
                return actionTemplate;
            })
        );
    };
}


export function clearActionTemplate() {
    return (dispatch) => {
        dispatch({type: types.ACTION_TEMPLATE_CLEAR});
    };
}


export function createActionTemplateAndCloseDrawer(actionTemplateObject, filter, onSuccess = ()=>{}, parentOrigin = null) {
    const origin = captureEditorOrigin(parentOrigin);
    return (dispatch, getState)=>{
        if (origin && !questionEditorAnswerTargetMatches(origin, getState(), actionTemplateObject.answerIndex)) {
            const error = new Error("Select an active answer before creating an action.");
            dispatch(notificationOpen(error.message));
            return runTrackedTemplateSave(dispatch, () => Promise.reject(error));
        }
        return runTrackedTemplateSave(dispatch, () =>
            TemplateApi.createActionTemplate(actionTemplateObject)
            .then((actionTemplate) =>{
                dispatch({type: types.ACTION_TEMPLATE_CREATE_SUCCESS, actionTemplate, origin});
                runIfEditorOwnerActive(getState, origin, () => {
                    onSuccess();
                    dispatch(closeDrawer());
                });
                dispatch(initGetTemplateList(filter, TEMPLATE.TYPE.ACTION, TEMPLATE.MODE.CURRENT));

                if (actionTemplateObject.answerIndex || actionTemplateObject.answerIndex === 0) {
                    dispatch({
                        type: types.QUESTION_EDITOR_ADD_ACTION,
                        actionTemplate,
                        answerIndex: actionTemplateObject.answerIndex,
                        depth: origin?.depth ?? 0,
                        origin
                    });
                }
                return actionTemplate;
            })
        );
    };
}
